import { render, staticRenderFns } from "./BrandingSettings.vue?vue&type=template&id=782924cd&"
import script from "./BrandingSettings.vue?vue&type=script&lang=js&"
export * from "./BrandingSettings.vue?vue&type=script&lang=js&"
import style0 from "./BrandingSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports